/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CallingIdentity } from './CallingIdentity';
import {
    CallingIdentityFromJSON,
    CallingIdentityFromJSONTyped,
    CallingIdentityToJSON,
} from './CallingIdentity';
import type { Direction } from './Direction';
import {
    DirectionFromJSON,
    DirectionFromJSONTyped,
    DirectionToJSON,
} from './Direction';
import type { LookupMappings } from './LookupMappings';
import {
    LookupMappingsFromJSON,
    LookupMappingsFromJSONTyped,
    LookupMappingsToJSON,
} from './LookupMappings';
import type { PromptGroups } from './PromptGroups';
import {
    PromptGroupsFromJSON,
    PromptGroupsFromJSONTyped,
    PromptGroupsToJSON,
} from './PromptGroups';

/**
 * 
 * @export
 * @interface UpdatePromptRevisionRequestContent
 */
export interface UpdatePromptRevisionRequestContent {
    /**
     * 
     * @type {string}
     * @memberof UpdatePromptRevisionRequestContent
     */
    name: string;
    /**
     * 
     * @type {PromptGroups}
     * @memberof UpdatePromptRevisionRequestContent
     */
    promptGroups: PromptGroups;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePromptRevisionRequestContent
     */
    directEdit?: boolean;
    /**
     * 
     * @type {CallingIdentity}
     * @memberof UpdatePromptRevisionRequestContent
     */
    callingIdentity: CallingIdentity;
    /**
     * 
     * @type {LookupMappings}
     * @memberof UpdatePromptRevisionRequestContent
     */
    queueIds?: LookupMappings;
    /**
     * 
     * @type {Direction}
     * @memberof UpdatePromptRevisionRequestContent
     */
    initialDirection?: Direction;
    /**
     * 
     * @type {number}
     * @memberof UpdatePromptRevisionRequestContent
     */
    duration?: number;
}


/**
 * Check if a given object implements the UpdatePromptRevisionRequestContent interface.
 */
export function instanceOfUpdatePromptRevisionRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "promptGroups" in value;
    isInstance = isInstance && "callingIdentity" in value;

    return isInstance;
}

export function UpdatePromptRevisionRequestContentFromJSON(json: any): UpdatePromptRevisionRequestContent {
    return UpdatePromptRevisionRequestContentFromJSONTyped(json, false);
}

export function UpdatePromptRevisionRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePromptRevisionRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'promptGroups': PromptGroupsFromJSON(json['promptGroups']),
        'directEdit': !exists(json, 'directEdit') ? undefined : json['directEdit'],
        'callingIdentity': CallingIdentityFromJSON(json['callingIdentity']),
        'queueIds': !exists(json, 'queueIds') ? undefined : LookupMappingsFromJSON(json['queueIds']),
        'initialDirection': !exists(json, 'initialDirection') ? undefined : DirectionFromJSON(json['initialDirection']),
        'duration': !exists(json, 'duration') ? undefined : json['duration'],
    };
}

export function UpdatePromptRevisionRequestContentToJSON(value?: UpdatePromptRevisionRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'promptGroups': PromptGroupsToJSON(value.promptGroups),
        'directEdit': value.directEdit,
        'callingIdentity': CallingIdentityToJSON(value.callingIdentity),
        'queueIds': LookupMappingsToJSON(value.queueIds),
        'initialDirection': DirectionToJSON(value.initialDirection),
        'duration': value.duration,
    };
}

